import Vuex from 'vuex'
import Vue from 'vue'

import axios from 'axios'
import moment from 'moment-timezone'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showingSchedule: false,
    classes: [],
    selectedAppointment: null,
    appointments: [],
    sortedClassesByDay: [],
    currentWeek: [],
    week: {
      mon: [],
      tue: [],
      wed: [],
      thu: [],
      fri: [],
      sat: [],
      san: []
    },
    weekDays: {
      "monday": 1,
      "tuesday": 2,
      "wednesday": 3,
      "thursday": 4,
      "friday": 5,
      "saturday": 6,
      "sunday": 7
    }
  },
  mutations: {
    showSchedule(state) {
      state.showingSchedule = true
    },
    hideSchedule(state) {
      state.showingSchedule = false
    },
    toggleSchedule(state) {
      state.showingSchedule = !state.showingSchedule
    },
    setClasses(state, data) {
      state.classes = data
    },
    setAppointments(state, data) {
      state.appointments = data
    },
    setSelectedAppointments(state, data) {
      state.selectedAppointment = data
    },
    generateCurrentWeek(state) {
      for(let i = 0; i < 7; i++) {
        state.currentWeek.push(moment().isoWeekday(i).format('YYYY-M-D'))
      }
    }
  },
  actions: {
    getAllClasses({ state, commit }) {
      commit('generateCurrentWeek')
      axios.get(process.env.BASE_URL, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        },
        mode: 'no-cors',
        crossDomain: true
      })
        .then((response) => {
          let tmp = []
          Object.keys(response.data).forEach(function(key) {
            let value = response.data[key]
            let index = state.weekDays[key.toLowerCase()]
            const newClass = []
            value.forEach((lesson) => {
              let newLesson = {}
              newLesson.id = lesson.id
              newLesson.name = lesson.name
              newLesson.day = lesson.day
              newLesson.duration = lesson.duration
              newLesson.time = lesson.localeTime
              newLesson.start = lesson.localeTime
              newLesson.end = moment(newLesson.time, 'h:mm A').add(newLesson.duration, 'm').format("h:mm A")
              newLesson.timeZone = lesson.calendarTimezone
              newLesson.color = lesson.color
              newLesson.typeId = lesson.appointmentTypeID
              newLesson.top = null
              newLesson.left = null
              newLesson.url = lesson.url
              newLesson.category = lesson.category

              newClass.push(newLesson)
            })
            tmp[index] = {
              key: key,
              value: newClass
            }
          })
          let orderedData = {}
          tmp.forEach(function(obj) {
            obj.value.sort((a, b) => {
              return moment(a.time, 'h:mm A') - moment(b.time, 'h:mm A')
            })
            orderedData[obj.key] = obj.value
          })
          commit('setClasses', orderedData)
          commit('showSchedule')

        })
        .catch((error) => {
          console.info(error)
        })
    },
    getAllAppointments({ state, commit }) {
      axios.get(process.env.APPOINTMENT_URL, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        },
        mode: 'no-cors',
        crossDomain: true
      })
        .then((response) => {
          let newAppointment = []
          newAppointment = response.data
          newAppointment.unshift({
            name: 'All Classes',
            id: null
          })
          commit('setAppointments', newAppointment)
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js